<template>
  <page-side-bar-menu :menus="menus"></page-side-bar-menu>
</template>

<script>
import PageSideBarMenu from "@/components/PageSideBarMenu";

export default {
  name: "Sidebar",
  data() {
    return {
      menus: [
        {title: 'About', active: this.isActive(1), 'url': '/tpo/about'},
        {title: 'Goals & Objectives', active: this.isActive(2), 'url': '/tpo/goals-objectives'},
        {title: 'Team', active: this.isActive(3), 'url': '/tpo/team'},
        {title: 'Infrastructure', active: this.isActive(4), 'url': '/tpo/infrastructure'},
        {title: 'Practices & Trainings Conducted', active: this.isActive(5), 'url': '/tpo/training-practices-facilities'},
        {title: 'Placement Rules and Regulations', active: this.isActive(6), 'url': '/tpo/placement-rules'},
        {title: 'Major Recruiters', active: this.isActive(7), 'url': '/tpo/major-recruiters'},
        {title: 'Yearly Placement Record', active: this.isActive(8), 'url': '/tpo/placement-record'},
        {title: 'MOUs', active: this.isActive(9), 'url': '/tpo/mous'},
        {title: 'Higher Education Opportunities and Guidance', active: this.isActive(10), 'url': '/tpo/higher-education-opportunities'},
        {title: 'IMP Links and Downloads', active: this.isActive(11), 'url': '/tpo/imp-links-downloads'},
        {title: 'Photo Gallery', active: this.isActive(12), 'url': '/tpo/gallery'},
      ]
    }
  },
  props: {
    active: {
      default: 1,
      type: Number
    }
  },
  methods: {
    isActive(index) {
      return this.active === index;
    }
  },
  components: {
    PageSideBarMenu
  }
}
</script>

<style scoped>

</style>
